import React from 'react';

/*
 * Pre-chunk portal loader (SKY-513): App.tsx shows this while feature flags
 * resolve and while the lazy portal bundle downloads — i.e. BEFORE circle.css
 * and the portal fonts exist in the document. Self-contained by necessity:
 * the values below mirror src/portal/theme/_colors.css / _dark.css (paper-0,
 * line-1, green-600, ink-900, ink-500) — update both together. Fonts use the
 * same fallback stacks the theme declares (Georgia serif / Helvetica sans).
 */
export const PortalLoader: React.FC<{ subMessage?: string }> = ({
  subMessage = 'Loading your portal…',
}) => (
  <div className="portal-loader" role="status" aria-live="polite">
    <style>{`
      .portal-loader {
        position: fixed; inset: 0; display: flex; flex-direction: column;
        align-items: center; justify-content: center; gap: 0;
        background: #FCFBF8; color: #10201A;
      }
      .portal-loader__ring {
        position: relative; width: 56px; height: 56px; margin-bottom: 32px;
      }
      .portal-loader__ring::before, .portal-loader__ring::after {
        content: ''; position: absolute; inset: 0; border-radius: 50%;
        border: 2px solid #E5E2D9;
      }
      .portal-loader__ring::before {
        animation: skeleton-breathe 2s ease-in-out infinite;
      }
      .portal-loader__ring::after {
        border-color: transparent; border-top-color: #196449;
        animation: portal-loader-spin 1s linear infinite;
      }
      .portal-loader__dots { display: flex; gap: 6px; margin-top: 24px; }
      .portal-loader__dots span {
        width: 4px; height: 4px; border-radius: 50%; background: #D5D1C5;
        animation: dot-pulse 1.5s ease-in-out infinite;
      }
      .portal-loader__dots span:nth-child(2) { animation-delay: 200ms; }
      .portal-loader__dots span:nth-child(3) { animation-delay: 400ms; }
      .portal-loader__title {
        margin: 0 0 8px; font: normal 22px/1.2 "Instrument Serif", Georgia, serif;
        letter-spacing: -0.01em;
      }
      .portal-loader__sub {
        margin: 0; font: normal 14px/1.4 "Instrument Sans", "Helvetica Neue", Arial, sans-serif;
        color: #5C6B63;
      }
      @keyframes portal-loader-spin {
        from { transform: rotate(0deg); } to { transform: rotate(360deg); }
      }
      [data-theme="dark"] .portal-loader, .portal-loader:where([data-theme="dark"] *) {
        background: #0E1713; color: #FCFBF8;
      }
      [data-theme="dark"] .portal-loader .portal-loader__ring::before,
      .portal-loader:where([data-theme="dark"] *) .portal-loader__ring::before {
        border-color: #243129;
      }
      [data-theme="dark"] .portal-loader .portal-loader__sub,
      .portal-loader:where([data-theme="dark"] *) .portal-loader__sub {
        color: #9DABA2;
      }
    `}</style>
    <div className="portal-loader__ring" aria-hidden="true" />
    <h2 className="portal-loader__title">Just a moment</h2>
    <p className="portal-loader__sub">{subMessage}</p>
    <div className="portal-loader__dots" aria-hidden="true"><span /><span /><span /></div>
  </div>
);
